import type {ReactElement} from 'react';
import {ColorControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/color-control/color-control';
import {ICON_VECTOR_TICK_FILL_PROP} from '@FormMakerReact/components/postermywall-icon-vector/postermywall-icon-vector';
import {DEFAULT_ICON_VECTOR_TICK_COLOR} from '@FormMakerReact/layout/form-maker-right-panel/sectors/sectors.constants';
import type {IconVectorTickColorControlProps} from './icon-vector-tick-color-control.types';

export function IconVectorTickColorControl({component}: IconVectorTickColorControlProps): ReactElement {
  return (
    <ColorControl
      component={component}
      property={ICON_VECTOR_TICK_FILL_PROP}
      labelKey="pmwjs_icon_color"
      pickAriaKey="pmwjs_icon_color"
      clearAriaKey="pmwjs_icon_color"
      defaultColor={DEFAULT_ICON_VECTOR_TICK_COLOR}
      hideClearButton
    />
  );
}
